import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupSelectFamilyRedirect() {
    const navigate = useNavigate();
    
    

    return (
        <div className=" text-whitex ">
        <div id="page">
        <ToastContainer />
        <div className="page-content pb-0">
                
        <div className="row" style={{ marginTop: '2%' }}>
        <div className="col-12 col-md-3 ">

      </div>
      <div className="col-12 col-md-6 ">
        <div className="card  border-0  text-white mt-5 mt-md-0 " >
          <div className="card-body  bg-med-green">
            <div className="row" style={{ marginTop: '5%' }}>
              <center>
                <label style={{ fontWeight: 900, fontSize: 20 }}>
                  You've sent your invitation message. Now, please wait for a family admin to add you to the family. You'll
                  receive a text notification once you've been added.
                </label>
              </center>
            </div>

            <div className="row" style={{ marginTop: '5%', marginBottom: '2%' }}>
              <div className="col-1 col-md-1"></div>
              <div className="col-6 col-md-6">
                <a href="https://oret.africa/">
                  <button className="btn btn-primary">Check our website</button>
                </a>
              </div>
              <div className="col-2 col-md-2"></div>
              <div className="col-3 col-md-3">
                <Link to='/' className='btn btn-default'>Close</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
                  
        </div>
            
        </div>
    </div>
    );
}

export default SignupSelectFamilyRedirect;
